// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewText_root__KJhkh","social":"ReviewText_social__w_fI_","link":"ReviewText_link__EHzfs"};